













import { Component, Prop, Vue } from 'vue-property-decorator';
import DirectionsLink from '@/components/common/DirectionsLink.vue';

@Component({
  components: {
    DirectionsLink,
  },
})
export default class PickupAddress extends Vue {
  @Prop({ required: true }) private readonly address!: string;

  @Prop({ required: true }) private readonly phone!: string;
}

